import React, { Children } from 'react';
import { motion } from 'framer-motion';
const anchors = [{
  num: '01',
  title: 'Glucémica',
  desc: 'Cómo sube y baja tu azúcar… y cómo eso dispara el calor'
}, {
  num: '02',
  title: 'Nerviosa',
  desc: 'El momento exacto donde tu cuerpo decide activar el bochorno'
}, {
  num: '03',
  title: 'Térmica',
  desc: 'Tu entorno… que puede ayudarte o sabotearte sin que lo notes'
}, {
  num: '04',
  title: 'Metabólica',
  desc: 'El tipo de movimiento que estabiliza… o empeora todo'
}, {
  num: '05',
  title: 'Tóxica',
  desc: 'Los elementos invisibles que afectan tu equilibrio hormonal'
}, {
  num: '06',
  title: 'Emocional',
  desc: 'Cómo interpretas lo que sientes… y cómo eso cambia tu cuerpo'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.22, 1, 0.36, 1]
    }
  }
};
export function AnchorsGrid() {
  return <motion.div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 mt-12" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
    once: true,
    margin: '-100px'
  }} data-id="element-1">
      {anchors.map((anchor, idx) => <motion.div key={idx} variants={itemVariants} className="bg-white/60 backdrop-blur-sm p-8 border border-sand/50 rounded-sm shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-2">
          <span className="font-serif text-terracotta text-xl italic block mb-3" data-id="element-3">
            {anchor.num}
          </span>
          <h3 className="font-serif text-2xl mb-3 text-charcoal" data-id="element-4">
            — {anchor.title}
          </h3>
          <p className="text-charcoal/80 font-light leading-relaxed" data-id="element-5">
            {anchor.desc}
          </p>
        </motion.div>)}
    </motion.div>;
}